// @flow
import type { ExtendedSuggestion } from '../../types';

export const getMinDuration = (
  suggestion: ExtendedSuggestion,
): void | number => {
  const phase = suggestion.phase;
  const prices = suggestion.prices?.create;

  if (!phase || !prices || !prices[suggestion.phase]) {
    // eslint-disable-next-line no-console
    console.error(
      'getMinDuration(suggestion) called with incomplete suggestion pricing.',
    );
  }

  return prices?.[phase]?.discount
    ? prices[phase].discount.minDuration
    : prices?.[phase]?.minDuration;
};
